import React from "react";
import { SequentialForm } from "../../SequentialStore/form";
import { uniqueId } from "lodash";

export const SequenceContext = React.createContext<SequentialForm.Sequential.SequenceType>({
  orderNumber: -1,
  actionType: "UNDECIDED",
  id: uniqueId(),
});
